/* eslint-disable import/prefer-default-export */

import {
  HAS_VIDEO_ATTR,
  IS_VIDEO_ATTR,
  IS_EXTERNAL_LINK_ATTR
} from 'oxygen-lib-ui/constants/teasers';
import { hasTermWithSlug } from 'util/terms';
import { isExternalLink, isVideoLink } from 'util/link';

/**
 * adds values to a Teaser's teaserAttribute array depending on
 * different qualities of the linked content.
 *
 * Currently it checks for video content and whether or not
 * the Teaser's link goes to a url external to the site.
 * The checks we use for external links and video content use different
 * paths, the actual url for videos and the router path for external links.
 *
 * @param {Object[]} tags[] array of { name, slug } objects
 * @param {Object} [theArg={}] properties that define features of the teaser
 * @returns {String[]} array of tags
 */
export function updateTeaserAttributes(attrs = [], { url, tags } = {}) {
  const newAttrs = [...attrs];

  if (isVideoLink(url)) {
    newAttrs.push(IS_VIDEO_ATTR);
    // Add 'hasVideo' only if it's not already flagged as a video permalink
  } else if (hasTermWithSlug(tags, 'video')) {
    newAttrs.push(HAS_VIDEO_ATTR);
  }

  if (isExternalLink(url)) {
    newAttrs.push(IS_EXTERNAL_LINK_ATTR);
  }

  return newAttrs;
}
